/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function TableTagRelationConnectionRepresentationFromJSON(json) {
    return TableTagRelationConnectionRepresentationFromJSONTyped(json, false);
}
export function TableTagRelationConnectionRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        dimensionTagId: json['dimensionTagId'],
        connectedDimensionTagId: json['connectedDimensionTagId'],
    };
}
export function TableTagRelationConnectionRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        dimensionTagId: value.dimensionTagId,
        connectedDimensionTagId: value.connectedDimensionTagId,
    };
}
